<template>
  <div
    class="leading-none p-2 rounded-t-md border-t border-l border-r border-gray-roc cursor-pointer hover:bg-gray-roc hover:text-white duration-300 transition uppercase font-medium text-xs"
    :class="{
      'bg-gray-roc text-white': active,
    }"
    @click="clicked"
  >
    {{ tabTitle }}
  </div>
</template>

<script>
export default {
  props: {
    tabId: {
      type: String,
      required: true
    },
    tabTitle: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    }
  },
  emits: ['click'],
  setup (props, context) {
    return {
      clicked() {
        context.emit('click', props.tabId);
      }
    };
  }
};
</script>
